import { Component, OnInit, ViewChild } from '@angular/core';
import { LiteratureService } from '../../../core/services/literature.service';
import { GridDataResult, PageChangeEvent, DataStateChangeEvent } from '@progress/kendo-angular-grid';
import { orderBy, process, State, SortDescriptor } from '@progress/kendo-data-query';
import { ActivatedRoute } from '@angular/router';
import { ILiteratureDocumentDetails, IParentPdfCollection, IPdfDocument, ParentPdfCollection, ILiteratureDocumentLabel, User } from '../../../core/models';
import { PanelBarExpandMode } from '@progress/kendo-angular-layout';
import { LanguageTranslationService } from '../../../core/services/language-translation.service';
import { environment } from 'src/environments/environment';
import { UserService } from '../../../core/services/user.service';
import { finalize } from 'rxjs/operators';

@Component({
  selector: 'app-details-screen',
  templateUrl: './details-screen.component.html',
  styleUrls: ['./details-screen.component.scss']
})
export class DetailsScreenComponent implements OnInit {
  //#region member/variable declaration
  documentTxt: ILiteratureDocumentLabel;
  @ViewChild('panelbar', { static: false }) panel;
  public expandMode: number = PanelBarExpandMode.Multiple;
  public kendoPanelBarExpandMode: any = PanelBarExpandMode;
  pdfDocuments: IPdfDocument[];
  parentPDFcollection: IParentPdfCollection[];

  filteredCollection: IParentPdfCollection[];
  filteredCollectionAdmin: IParentPdfCollection[];
  filteredChildCollection: IPdfDocument[];

  groupingId: string;
  imageUrl: string;
  hasAccessToAdmin: boolean;
  lieratureDetails: ILiteratureDocumentDetails;

  constructor(private literatureService: LiteratureService, private route: ActivatedRoute
    , private languageTranslationService: LanguageTranslationService, private userService: UserService  ) { }

  //#region label and variable declaration
  public pagelabels = {
    headingLbl: "Kawneer",
    note1Lbl: "Note: To view .PDF files, you must have Adobe® Reader™ Version 7.0 or higher.",
    note2Lbl: "To view the videos, click the video name listed below."
  }


  ngOnInit() {
    this.imageUrl = environment.imageUrl;
    this.loadLanguageTranslationData();
    this.route.params.subscribe(params => {
      this.groupingId = params.id;
    });
    if (this.groupingId) {
      this.loadGridData(this.groupingId);
    }
    //this.getPDFs();
    this.hasAccessToAdmin = this.userService.isMktAdmin();

  }
  //#region Language translate
  loadLanguageTranslationData() {
    const controlNameList = [
      { controlName: "headingLbl" },
      { controlName: "note1Lbl" },
      { controlName: "note2Lbl" },

    ];
    const componentName = "literaturedocument";
    const response = this.languageTranslationService.getLanguageTranslationList(controlNameList, componentName);
    if (response.length > 0) {
      this.documentTxt = response[response.length - 1];
    }
  }

  //#endregion

  //#region load document details
  loadGridData(groupingId) {
    const body = {
      id: groupingId
    }
    this.literatureService.getLieratureDetails(body).subscribe((response) => {
      console.log(response);
      this.lieratureDetails = response as ILiteratureDocumentDetails
      this.pdfDocuments = response.literature;
      var tempArr = this.copyArrayWithoutReference(this.pdfDocuments);
      this.filteredCollection = this.checkSubCategoryDuplicate(tempArr) as IParentPdfCollection[];
    });
    this.literatureService.getLieratureDetailsAdmin(body).subscribe((response) => {
      console.log(response);
      this.lieratureDetails = response as ILiteratureDocumentDetails
      this.pdfDocuments = response.literature;
      var tempArr = this.copyArrayWithoutReference(this.pdfDocuments);
      this.filteredCollectionAdmin = this.checkSubCategoryDuplicate(tempArr) as IParentPdfCollection[];
    });

  }

  //to check duplicate sub category
  checkSubCategoryDuplicate(arr: any) {
    if (arr.length > 0) {
      for (let list = 0; list < arr.length; list++) {
        for (let i = 0; i < arr[list].pdfCollection.length; i++) {
          for (let j = 0; j < arr[list].pdfCollection.length; j++) {
            // do not compare same elements
            if (i !== j) {
              // check if sub-category match
              if (arr[list].pdfCollection[i].docSubCategoryDesc === arr[list].pdfCollection[j].docSubCategoryDesc) {
                arr[list].pdfCollection[j].docSubCategoryDesc = ""; //empty the duplicate sub category
              }
            }
          }
        }
      }        
      //return Array.from(this.groupByCategoryIDs(arr));
      return arr;
    }
   
  }
  copyArrayWithoutReference(arr: IPdfDocument[]) {
    return Array.from(this.groupByCategoryIDs(arr));
  }

  // Find unique items in an array by the value of a property.
  getUniqueCategoryIDs(list: IPdfDocument[]) {
    return [...new Set(list.map(pdf => pdf.docCategoryID))];
    //return list.map(item => item.docCategoryID)
    //  .filter((value, index, self) => self.indexOf(value) === index)

    //const distinctCategory = list.filter(
    //  (thing, i, arr) => arr.findIndex(t => t.docCategoryID === thing.docCategoryID) === i
    //);
    //return distinctCategory
  }

  // Group PDF Documents By DocumentCategoryID
  groupByCategoryIDs(list: IPdfDocument[]) {

    this.parentPDFcollection = [];
    //const uniqueCategoryIDs = list.filter(
    //  (thing, i, arr) => arr.findIndex(t => t.docCategoryID === thing.docCategoryID) === i
    //);

    //const uniqueCategoryIDs = list.filter((thing, i, arr) => {
    //  return arr.indexOf(arr.find(t => t.docCategoryID === thing.docCategoryID)) === i;
    //});
    const uniqueCategoryIDs = this.getUniqueCategoryIDs(list);
    uniqueCategoryIDs.forEach(id => {
      const pdfs = list.filter(item => item.docCategoryID == id);

      // map all properties
      const parentPdf = new ParentPdfCollection();
      parentPdf.backgroundColor = pdfs[0].backgroundColor;
      parentPdf.docCategoryDesc = pdfs[0].docCategoryDesc;
      parentPdf.docCategoryID = pdfs[0].docCategoryID;
      parentPdf.docDesc = pdfs[0].docDesc;
      parentPdf.docGroupingAlias = pdfs[0].docGroupingAlias;
      parentPdf.docGroupingID = pdfs[0].docGroupingID;
      parentPdf.docSubCategoryDesc = pdfs[0].docSubCategoryDesc;
      parentPdf.docSubCategoryID = pdfs[0].docSubCategoryID;
      // parentPdf.languageCode = pdfs[0].languageCode;
      parentPdf.partNo = pdfs[0].partNo;
      parentPdf.pathName = pdfs[0].pathName;
      parentPdf.revision = pdfs[0].revision;

      parentPdf.pdfCollection = [];
      parentPdf.pdfCollection.push(...pdfs);

      // After mapping all the properties and inserting the PDF collection into the parent PDF
      // Push the single parent PDF into the Parent PDF collection
      this.parentPDFcollection.push(parentPdf);
    });

    return this.parentPDFcollection;
  }
  //#endregion 


  onSearchChangeFilter(query: string) {
    query = query.toLowerCase();

    if (query === '') {
      // If search textbox is empty, load the full list
      this.filteredCollection = this.copyArrayWithoutReference(this.pdfDocuments);
    } else {

      // The model used here has a Parent-Child relationship.
      // Parent is used in the UI on the PanelBar, and Child is used as the content under each PanelBar
      // For search, it needs to check if the Panel bar - the parent - text contains the search query.
      // In addition, it also needs to check the Panel content - the child - for the search query.
      // If parent contains search query, add it to Filtered collection (this collection is used to populate the KendoPanelBar control)
      // If the content - the child - contains the search query, even if the parent doesn't, it still needs to get the parent and add it to the Filtered collection.

      this.filteredCollection = [];
      // Search parent collection
      this.parentPDFcollection = this.copyArrayWithoutReference(this.pdfDocuments); // reset parent collection
      this.parentPDFcollection.forEach(parent => {
        const tempParent = parent;
        // First, search the parent
        const parentHasWord = tempParent.docCategoryDesc.toLowerCase().includes(query) ||
          tempParent.docSubCategoryDesc.toLowerCase().includes(query);

        // Then, search the child
        let childHasWord = false;
        this.filteredChildCollection = [];
        parent.pdfCollection.forEach(child => {

          childHasWord = child.docDesc.toLowerCase().includes(query) ||
            child.docCategoryDesc.toLowerCase().includes(query) ||
            child.docSubCategoryDesc.toLowerCase().includes(query)
            //child.partNo && child.partNo!="" ? child.partNo.toLowerCase().includes(query) : false ||
            //   child.revision && child.revision != "" ? child.revision.toLowerCase().includes(query) : false
            ;

          // Add current child to Child Collection
          if (childHasWord) {
            this.filteredChildCollection.push(child);

            tempParent.pdfCollection = Array.from(this.filteredChildCollection);
            this.filteredCollection.push(tempParent);
          }
        });
      });

      // Get distinct objects in array
      this.filteredCollection = [...new Set(this.filteredCollection)];
    }
  }
  //#New Change For Eco Enahancement

  //#EndRegion
  //onClickDownload(child: any) {
  //  console.log(child)
  //  this.literatureService.downloadFiles(child).subscribe((response) => {
  //    console.log("response: ", response);

  //    if (response) {
  //      const url = response.result.url;
  //      const linkSource = 'data:application/pdf;base64,' + url;
  //      const downloadLink = document.createElement("a");
  //      const fileName = child.partNo+'.pdf';
  //      downloadLink.href = linkSource;
  //      downloadLink.download = fileName;
  //      downloadLink.click();
  //    }
  //  });
  //}

  downloadingMap: { [key: string]: boolean } = {};
  onClickDownload(child: any) {
    child.pathName = child.pathName.trim();
    if (this.downloadingMap[child.docID]) {
      return;
    }
    console.log(child);
    this.downloadingMap[child.docID] = true;
    this.literatureService.downloadFilesLiterature(child)
    .pipe(
      finalize(() => {
        this.downloadingMap[child.docID] = false;
      })
    )
      .subscribe((response: any) => {
      console.log("response: ", response);
      const blob: Blob = (response && (response as any).body)
        ? (response as any).body
        : (response as Blob);
        if (blob) {
          console.log(blob.type);
          const fileName = ((child && child.partNo) ? child.partNo.replace(/\./g, '_') : 'download');
          //const fileName = ((child && child.partNo) ? partNo : 'download');
        const url = window.URL.createObjectURL(blob);
        const downloadLink = document.createElement('a');
        downloadLink.href = url;
        downloadLink.download = fileName;
        downloadLink.click();
        window.URL.revokeObjectURL(url);
        this.downloadingMap[child.docID] = false;
      }  
    });
  }

  //#New Change For Eco Enahancement
  approve(child: any) {
    console.log(child);
    this.literatureService.approveDocument(child).subscribe((response) => {
      console.log(response);
      this.ngOnInit();
    });
    this.route.params.subscribe(params => {
      this.groupingId = params.id;
    });
    if (this.groupingId) {
      this.loadGridData(this.groupingId);
    }
  }

  //#EndRegion
}



